import Vue from "vue";
import Vuex from "vuex";

import App from "./App.vue";
import "./plugins/element.js";
import "./assets/theme/index.css";
import router from "./router/index";
import { getRequest, postRequest, downloadRequest } from "./api/base";
import store from "./store/index";
import GeminiScrollbar from "vue-gemini-scrollbar";
import loginPlugins from "./components/common/loginPlugins";
import 'font-awesome/css/font-awesome.min.css';
Vue.prototype.$Login = loginPlugins.install;
Vue.use(GeminiScrollbar);
/** svg start */
import svg from "svg-progress-bar";
Vue.use(svg, { componentName: "svg-bar" });
/** svg end */

import mathJaxVariable from './config/mathJaxVariable'
Vue.prototype.commonsVariable = mathJaxVariable;

const html = ["A", "B", "C", "D","E","F","G","H","I","J","K"];
Vue.prototype.optionHtml = function(i, v) {
  // to do
  // let html = ["A", "B", "C", "D","E","F","G","H","I","J","K"];
  return html[i] + "." + v;
};
Vue.prototype.optionTexts = function(i) {
  // to do
  // let html = ["A", "B", "C", "D","E","F","G","H","I","J","K"];
  return html[i];
};
Vue.prototype.numHtml = function(num, v) {
  // to do
  return num + "." + v;
};
Vue.prototype.getRequest = getRequest;
Vue.prototype.postRequest = postRequest;
Vue.prototype.downloadRequest = downloadRequest;
Vue.use(Vuex);
Vue.config.productionTip = false;
//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
  // console.log(to)
  let auth = to.query.kc_auth;
  if (to.query.kc_token) {
    if (to.query.kc_token === "1") {
      next({ path: "/login" }); //跳到登录页面
      return false;
    }
    store.commit("USER_SIGNIN", {
      token: to.query.kc_token,
      role: to.query.role,
    });
  }
  if (to.query.kc_auth) {
    //全品学堂链接过来的请求
    getRequest("/wenjiaoopne/kc/auth/authCheck", { auth_code: auth })
      .then((result) => {
        if (result.error_code === 0) {
          store.commit("USER_SIGNIN", result.data);
          next({ path: "/" }); //放行
          return false;
        }
        if (result.data === 0) {
          loginPlugins.install();
          return false;
        }
        if (result.data === 1) {
          next({ path: "/login" }); //跳到登录页面
          return false;
        }
        next({ path: "/" }); //跳到404页面
        return false;
      })
      .catch(() => {});
  } else {
    document.title = `${to.meta.title}`;
    const user = store.state.user;
    const whiteList = ["/","/404", "/login", "/403", "/index","/terminal/video/exercise","/terminal/question","/terminal/error/question","/authorizerResult"];
    if (!user.token && whiteList.indexOf(to.path) === -1) {
      next({ path: "/login" }); //跳到登录页面
      return false;
    }
    if (
      (to.meta.roles && to.meta.roles.includes(user.role)) ||
      whiteList.indexOf(to.path) > -1
    ) {
      next(); //放行
      return false;
    }
    next({ path: "/" }); //跳到404页面
    return false;
  }
});
window.location.href = "https://www.canpoint.org.cn/"
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
